import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
  Screen,
  StatePicker,
  Text,
  TextInput,
} from '~/atomic';
import { useAppDispatch, useAppSelector } from '~/store';
import { selectQuotesSettings } from '~/store/quotes/selectors';
import {
  setEnabledProducts,
  setManualUf,
  setWeatherCity,
} from '~/store/quotes/slices';
import { fetchQuotes } from '~/store/quotes/thunks';
import type { QuoteProduct } from '~/store/quotes/interfaces';

const PRODUCT_LABELS: { key: QuoteProduct; label: string }[] = [
  { key: 'soja', label: 'Soja' },
  { key: 'milho', label: 'Milho' },
  { key: 'boi_gordo', label: 'Boi gordo' },
  { key: 'dolar', label: 'Dólar' },
];

export default function MarketSettingsView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { uf, weatherCity, enabledProducts } = useAppSelector(selectQuotesSettings);
  const [city, setCity] = useState(weatherCity ?? '');

  const toggleProduct = (p: QuoteProduct) => {
    const next = enabledProducts.includes(p)
      ? enabledProducts.filter((x) => x !== p)
      : [...enabledProducts, p];
    dispatch(setEnabledProducts(next));
  };

  const save = async () => {
    dispatch(setWeatherCity(city || null));
    await dispatch(fetchQuotes(uf));
    navigate(-1);
  };

  return (
    <Screen headerTitle="Configurações de mercado">
      <div className="flex flex-col gap-medium py-medium">
        <Box className="flex flex-col gap-smaller">
          <Text className="text-paragraphMD color-complement-01">Região</Text>
          <StatePicker value={uf} onChange={(v) => dispatch(setManualUf(v))} placeholder="UF" />
          <TextInput
            label="Cidade (clima)"
            value={city}
            onChangeText={setCity}
            icon="icon-pin-location"
            placeholder="Ex: Uberlândia"
          />
        </Box>

        <Box className="flex flex-col gap-smaller">
          <Text className="text-paragraphMD color-complement-01">Produtos</Text>
          {PRODUCT_LABELS.map(({ key, label }) => {
            const enabled = enabledProducts.includes(key);
            return (
              <button
                key={key}
                type="button"
                onClick={() => toggleProduct(key)}
                className="flex items-center justify-between px-small py-smaller rounded-small bg-intense-01 border border-intense-03"
              >
                <Text className="text-bodyLG color-complement-01">{label}</Text>
                <span
                  className={`h-[24px] w-[42px] rounded-full transition-colors flex items-center ${
                    enabled ? 'bg-primary-01 justify-end' : 'bg-intense-04 justify-start'
                  }`}
                >
                  <span className="h-[20px] w-[20px] mx-quark rounded-full bg-intense-01" />
                </span>
              </button>
            );
          })}
        </Box>

        <Button text="Salvar configurações" onClick={save} fullWidth />
      </div>
    </Screen>
  );
}
